import { useEffect, useState } from "react";
import { DestinationAccountControllerType } from "../useDestinationAccount";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Spacing from "../../../layout/spacing";
import { BodyLargeRegular, HeadlineMedium } from "../../../components/font";
import { LottieAnimation, type LottieAnimationProps } from "@manifesthhqinc/ui-library";
import { LottieAnimationDiv } from "../../general/styles";
import transformAccountTypeDisplayName from "../../../utils/transformAccountTypeDisplayName";

const FlashLoadingScreen = (props: DestinationAccountControllerType) => {
  const { onClickContinue, setIsLoading, setIsDestinationAnimationLoaded, sourceOfDestination, transferIntentDetails } =
    props;
  const [animationStep, setAnimationStep] = useState<number>(0);
  const [animationStep1Type, setAnimationStep1Type] = useState<LottieAnimationProps["type"]>("three-dot-loading");
  useEffect(() => {
    setIsLoading(true);
    setIsDestinationAnimationLoaded(true);
  }, []);

  const finishAccountLoading = () => {
    setAnimationStep(1);
    if (transferIntentDetails?.primaryDestination?.isOpened || sourceOfDestination === "CLIENT_OPTIONS") {
      setAnimationStep1Type("three-dot-loading-and-checked");
    }
  };

  const finishLoading = () => {
    onClickContinue();
    setIsLoading(false);
  };

  return (
    <TransitionWrapper>
      <ScrollableContainer name="loading">
        <Container>
          <LottieAnimationDiv>
            {animationStep === 0 ? (
              <LottieAnimation type="three-dot-loading" onComplete={finishAccountLoading} width={200} height={200} />
            ) : (
              <>
                <LottieAnimation
                  type={animationStep1Type}
                  width={200}
                  height={200}
                  onComplete={finishLoading}
                  loop={animationStep1Type === "three-dot-loading" ? 0.5 : false}
                />
              </>
            )}
          </LottieAnimationDiv>

          <HeadlineMedium className="text-center">Just a moment...</HeadlineMedium>
          <Spacing vertical="15" />
          <BodyLargeRegular className="text-center">
            {sourceOfDestination === "CLIENT_FIX"
              ? `Connecting your ${transferIntentDetails?.primaryDestination?.providerName} ${transformAccountTypeDisplayName(transferIntentDetails?.primaryDestination?.type)}`
              : "Seeing if you have any existing accounts to transfer into."}
          </BodyLargeRegular>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};

export default FlashLoadingScreen;
